import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestWorkspaceUserOwnershipTransferCreate } from '@shared/dto/+workspace/workspace_transfer_ownership_proposal/_requests/request_workspace_transfer_ownership_create';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__workspace } from '../STATE__workspace';

export const remote_workspace_transfer_ownership_proposal_create = createAsyncThunkSafe<void, RequestWorkspaceUserOwnershipTransferCreate>(
  ENUM__network_event_client_to_server.WORKSPACE_TRANSER_OWNERSHIP_CREATE,
  async (request): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORKSPACE_TRANSER_OWNERSHIP_CREATE, request);
  },
);

export function init_remote_workspace_transfer_ownership_proposal_create(builder: ActionReducerMapBuilder<STATE__workspace>) {
  builder
    .addCase(remote_workspace_transfer_ownership_proposal_create.pending, (state, action) => {})
    .addCase(remote_workspace_transfer_ownership_proposal_create.rejected, (state, action) => {})
    .addCase(remote_workspace_transfer_ownership_proposal_create.fulfilled, (state, action: PayloadAction) => {});
}
